var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"dense":"","outlined":"","disabled":_vm.disabled},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"info--text",domProps:{"textContent":_vm._s(_vm.label)}})]},proxy:true}]),model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }